export const opt = [
    {
        name: "Bank Teller",
        value: "1",
    },
    {
        name: "Internet Banking",
        value: "2",
    },
    {
        name: "Mobile Phone",
        value: "3",
    },
];

export const opt2 = [
    {
        name: "Level 1",
        value: "1",
    },
    {
        name: "Level 2",
        value: "2",
    },
    {
        name: "Level 3",
        value: "3",
    },
];

export default { opt, opt2 };